<div class="mb-3" *ngIf="aciklamaGecmisiTalep">
  <div class="form-label">Talep Açıklama Geçmişi</div>
  <div class="list list-row list-hoverable">
    <div class="list-item" *ngFor="let a of aciklamaGecmisiTalep">
      <div class="text-body d-block"><strong>{{a.kullanici?.adSoyad}}: </strong>
        {{a.aciklama}}
      </div>
    </div>
  </div>
</div>
<div class="mb-3" *ngIf="aciklamaGecmisiFatura">
  <div class="form-label">Fatura Açıklama Geçmişi</div>
  <div class="list list-row list-hoverable">
    <div class="list-item" *ngFor="let a of aciklamaGecmisiFatura">
      <div class="text-body d-block"><strong>{{a.kullanici?.adSoyad}}: </strong>
        {{a.aciklama}}
      </div>
    </div>
  </div>
</div>